module.exports = __webpack_public_path__ + "assets/plus-folder.c2cdbf0f.svg";